import React, { useState } from 'react'
import { Phone, Mail } from 'lucide-react'

function FloatingContact() {
  const [phoneHovered, setPhoneHovered] = useState(false)
  const [emailHovered, setEmailHovered] = useState(false)

  return (
    <div
      className="fixed right-0 top-1/2 -translate-y-1/2 z-50 flex flex-col items-end gap-4 pointer-events-none"
      data-dev-id="src/components/FloatingContact.jsx:container"
    >
      <div className="pointer-events-none flex w-fit justify-end">
        <a
          href="tel:+4524460485"
          onMouseEnter={() => setPhoneHovered(true)}
          onMouseLeave={() => setPhoneHovered(false)}
          className={`pointer-events-auto inline-flex w-fit items-center bg-amber-500 hover:bg-slate-900 text-slate-950 hover:text-white p-4 rounded-l-sm transition-[transform,background-color,color,border-color,box-shadow] duration-500 ease-out font-black text-xs md:text-sm tracking-wider uppercase border-l-4 border-amber-600/50 hover:border-amber-500 whitespace-nowrap shadow-sm hover:shadow-md will-change-transform ${
            phoneHovered ? '-translate-x-2' : ''
          }`}
          title="Ring til os"
          data-dev-id="src/components/FloatingContact.jsx:phone-btn"
        >
          <Phone className="w-5 h-5 shrink-0" />
          <span
            className={`overflow-hidden transition-all duration-300 ease-in-out ${
              phoneHovered ? 'max-w-xs opacity-100 ml-3' : 'max-w-0 opacity-0'
            }`}
          >
            (+45) 24 46 04 85
          </span>
        </a>
      </div>

      <div className="pointer-events-none flex w-fit justify-end">
        <a
          href="mailto:jp@jpstaal.dk"
          onMouseEnter={() => setEmailHovered(true)}
          onMouseLeave={() => setEmailHovered(false)}
          className={`pointer-events-auto inline-flex w-fit items-center bg-amber-500 hover:bg-slate-900 text-slate-950 hover:text-white p-4 rounded-l-sm transition-[transform,background-color,color,border-color,box-shadow] duration-500 ease-out font-black text-xs md:text-sm tracking-wider uppercase border-l-4 border-amber-600/50 hover:border-amber-500 whitespace-nowrap shadow-sm hover:shadow-md will-change-transform ${
            emailHovered ? '-translate-x-2' : ''
          }`}
          title="Send en mail"
          data-dev-id="src/components/FloatingContact.jsx:email-btn"
        >
          <Mail className="w-5 h-5 shrink-0" />
          <span
            className={`overflow-hidden transition-all duration-300 ease-in-out ${
              emailHovered ? 'max-w-xs opacity-100 ml-3' : 'max-w-0 opacity-0'
            }`}
          >
            jp@jpstaal.dk
          </span>
        </a>
      </div>
    </div>
  )
}

export default FloatingContact
